import React, { useState } from 'react';
import { supabase } from '../supabase';
import * as db from '../db';
import useStore from '../store/useStore';

export default function PasswordChangeGate({ user }) {
  const [newPw,   setNewPw]   = useState('');
  const [confirm, setConfirm] = useState('');
  const [error,   setError]   = useState('');
  const [saving,  setSaving]  = useState(false);

  const handleSubmit = async () => {
    if (newPw.length < 10)  { setError('Password must be at least 10 characters'); return; }
    if (newPw !== confirm)   { setError('Passwords do not match'); return; }
    setError('');
    setSaving(true);
    try {
      const { error: authErr } = await supabase.auth.updateUser({ password: newPw });
      if (authErr) throw authErr;
      await db.markPasswordChanged(user.id);
      useStore.getState().setUser({ ...user, passwordChanged: true });
    } catch (err) {
      setError(err.message || 'Failed to update password');
      setSaving(false);
    }
  };

  const inputStyle = {
    width: '100%', boxSizing: 'border-box', padding: '9px 12px',
    border: '1px solid #D7D9DF', borderRadius: 8, fontSize: 14,
    fontFamily: 'inherit', outline: 'none',
  };
  const labelStyle = { fontSize: 12, fontWeight: 600, color: '#5A606C', display: 'block', marginBottom: 5 };

  return (
    <div style={{ minHeight: '100vh', background: '#F7F7F9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit' }}>
      <div style={{ background: '#fff', border: '1px solid #E7E8EC', borderRadius: 16, padding: 36, width: '100%', maxWidth: 400, boxShadow: '0 8px 32px -12px rgba(0,0,0,0.12)' }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: '#1E2128', marginBottom: 6 }}>Set a new password</div>
        <div style={{ fontSize: 13, color: '#767C89', marginBottom: 24 }}>Your account requires a password change before you can continue.</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={labelStyle}>New password</label>
            <input type="password" value={newPw} onChange={e => setNewPw(e.target.value)} placeholder="8+ characters" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Confirm password</label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat password" style={inputStyle} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
          </div>
          {error && (
            <div style={{ padding: '8px 12px', background: '#fef2f2', color: '#dc2626', borderRadius: 8, fontSize: 12 }}>{error}</div>
          )}
          <button
            onClick={handleSubmit}
            disabled={saving}
            style={{ marginTop: 4, padding: '10px 0', background: 'oklch(0.52 0.16 285)', color: '#fff', border: 'none', borderRadius: 9, fontSize: 14, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1, fontFamily: 'inherit' }}
          >
            {saving ? 'Saving…' : 'Set password & continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
